export default __webpack_public_path__ + "static/media/sector_3w.f02f6508.jpg";